import { render, staticRenderFns } from "./SideMessage.vue?vue&type=template&id=7160cd13&scoped=true&"
import script from "./SideMessage.vue?vue&type=script&lang=js&"
export * from "./SideMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7160cd13",
  null
  
)

export default component.exports